import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth';

const INACTIVITY_MS = 15 * 60 * 1000;
const COUNTDOWN_S   = 60;
const EVENTS        = ['mousemove', 'keydown', 'click', 'touchstart'] as const;

@Injectable({ providedIn: 'root' })
export class InactivityService {
  private auth   = inject(AuthService);
  private router = inject(Router);

  readonly modalVisible = signal(false);
  readonly countdown    = signal(COUNTDOWN_S);

  private inactivityTimer: ReturnType<typeof setTimeout>  | null = null;
  private countdownTimer:  ReturnType<typeof setInterval> | null = null;

  // Arrow fn to keep `this` context when used as event listener
  private readonly onActivity = () => {
    if (!this.modalVisible()) this.resetTimer();
  };

  start(): void {
    EVENTS.forEach(e => document.addEventListener(e, this.onActivity, { passive: true }));
    this.scheduleTimeout();
  }

  stop(): void {
    EVENTS.forEach(e => document.removeEventListener(e, this.onActivity));
    this.clearTimers();
    this.modalVisible.set(false);
  }

  continuarSesion(): void {
    this.clearTimers();
    this.modalVisible.set(false);
    this.scheduleTimeout();
  }

  cerrarSesion(): void {
    this.stop();
    this.auth.clearSession();
    this.router.navigate(['/auth/login']);
  }

  private resetTimer(): void {
    this.clearTimers();
    this.scheduleTimeout();
  }

  private scheduleTimeout(): void {
    this.inactivityTimer = setTimeout(() => {
      this.modalVisible.set(true);
      this.countdown.set(COUNTDOWN_S);
      this.startCountdown();
    }, INACTIVITY_MS);
  }

  private startCountdown(): void {
    this.countdownTimer = setInterval(() => {
      const remaining = this.countdown() - 1;
      if (remaining <= 0) {
        this.cerrarSesion();
      } else {
        this.countdown.set(remaining);
      }
    }, 1000);
  }

  private clearTimers(): void {
    if (this.inactivityTimer) { clearTimeout(this.inactivityTimer);  this.inactivityTimer = null; }
    if (this.countdownTimer)  { clearInterval(this.countdownTimer);  this.countdownTimer  = null; }
  }
}
